import React from 'react';
import { Input } from 'reactstrap';
import TelefoneBrasileiroInput from 'react-telefone-brasileiro';

export const InputPhone = ({ ...rest }) => {
  return (
    <Input
      {...rest}
      type="tel"
      temDDD
      separaNono
      separaDDD
      className="form-control"
      tag={TelefoneBrasileiroInput}
    />
  );
};
